import { ToggleButton, ToggleButtonGroup, ToggleButtonGroupProps } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { AuroraControlMode } from '../enums'

export interface AuroraControlModeToggleProps extends Omit<
  ToggleButtonGroupProps,
  'exclusive' | 'onChange' | 'value'
> {
  mode: AuroraControlMode
  onModeChange: (value: AuroraControlMode) => void
}

export default function AuroraControlModeToggle({
  mode,
  onModeChange,
  ...props
}: AuroraControlModeToggleProps) {
  const { t } = useTranslation('aurora')

  const handleChange = (event: React.MouseEvent<HTMLElement>, value: AuroraControlMode | null) => {
    if (value) {
      onModeChange(value)
    }
  }

  return (
    <ToggleButtonGroup exclusive color="primary" value={mode} {...props} onChange={handleChange}>
      <ToggleButton value={AuroraControlMode.STACK}>{t('stackControl')}</ToggleButton>
      <ToggleButton value={AuroraControlMode.UNIT}>{t('unitControl')}</ToggleButton>
    </ToggleButtonGroup>
  )
}
